/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_SkipInputs */

const en_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip for now (30 days to verify)`)
};

const de_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überspringen (30 Tage zum Bestätigen)`)
};

const fr_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer pour l'instant (30 jours pour vérifier)`)
};

const es_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir por ahora (30 días para verificar)`)
};

const it_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta per ora (30 giorni per verificare)`)
};

const nl_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overslaan (30 dagen om te verifiëren)`)
};

const pl_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomiń na teraz (30 dni na weryfikację)`)
};

const fi_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohita nyt (30 päivää vahvistaa)`)
};

const da_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spring over for nu (30 dage til at bekræfte)`)
};

const sv_onboarding_verify_skip = /** @type {(inputs: Onboarding_Verify_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppa över för tillfället (30 dagar att verifiera)`)
};

/**
* | output |
* | --- |
* | "Skip for now (30 days to verify)" |
*
* @param {Onboarding_Verify_SkipInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_skip = /** @type {((inputs?: Onboarding_Verify_SkipInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_SkipInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_skip(inputs)
	if (locale === "fr") return fr_onboarding_verify_skip(inputs)
	if (locale === "es") return es_onboarding_verify_skip(inputs)
	if (locale === "it") return it_onboarding_verify_skip(inputs)
	if (locale === "nl") return nl_onboarding_verify_skip(inputs)
	if (locale === "pl") return pl_onboarding_verify_skip(inputs)
	if (locale === "fi") return fi_onboarding_verify_skip(inputs)
	if (locale === "da") return da_onboarding_verify_skip(inputs)
	if (locale === "sv") return sv_onboarding_verify_skip(inputs)
	return en_onboarding_verify_skip(inputs)
});